import React from 'react';
import {getRelativeTime} from 'app/components/tv/helpers/getRelativeTime';
import {LinkOnComponent} from 'app/components/links/link';
import {checkForUnwatchedVideo} from 'app/components/tv/helpers/lastViewedVideos';
import VideoPreview from 'app/components/tv/preview/VideoPreview';

const isSporttotalVideo = video => {
  return video.data.source === 'Sporttotal';
};

export const PlaylistTeaser = ({video, videosCount}) => {
  const unwatchedVideo = checkForUnwatchedVideo(video, videosCount);

  const updateTime = getRelativeTime(video.updatedAt);

  let caption = isSporttotalVideo(video) ? updateTime : `${video.data.videosCount} Clips | ${updateTime}`;

  return (
    <LinkOnComponent to={`/tv/match/${video.data.slug}`}>
      <VideoPreview
        thumbnail={video.thumbnail}
        updated={unwatchedVideo}
        source={video.data.source}
        title={video.data.creatorName ? `von ${video.data.creatorName}` : 'Video-Playlist'}
        caption={caption}
      />
    </LinkOnComponent>
  );
};
